import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";

import SpecialistApi from "../../../../api/specialistsApi";
import ModalWindow from "../../../../components/ModalWindow/ModalWindow";
import { ContextProvider } from "../../../../contextProvider";
import {
  AppreciationCertificate,
  Education,
  EducationCertificatesResponse,
  Federation,
  FederationsCertificatesResponse,
  QualificationCertificatesResponse,
} from "../../../../types/TypeSpecialist";
import { CertificatesData } from "../EducationSection";
import Appreciation from "./Appreciations/Appreciation";
import EducationsCertificates from "./EducationsCertificates/EducationsCertificates";
import FederationsCertificates from "./FederationsCertificates/FederationsCertificates";
import QualificationsCertificates from "./QualificationsCertificates/QualificationsCertificates";

type UpdateCertificatesModalProps = {
  modalOpen: boolean;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
  certificateType:
    | "education"
    | "qualification"
    | "federation"
    | "appreciation";
  specialistId: string;
  setNewCertificate?: Dispatch<SetStateAction<CertificatesData>>;
  setupUpdateCertificate?: (cert: any) => void;
  mainSpec: string;
  setShowSendReviewRequestBtn?: Dispatch<SetStateAction<boolean>>;
  educationToUpdate?: EducationCertificatesResponse;
  federationToUpdate?: FederationsCertificatesResponse;
  qualificationToUpdate?: QualificationCertificatesResponse;
  appreciationToUpdate?: AppreciationCertificate;
};

const UpdateCertificatesModal = ({
  modalOpen,
  setModalOpen,
  certificateType,
  specialistId,
  setNewCertificate,
  setupUpdateCertificate,
  mainSpec,
  setShowSendReviewRequestBtn,
  educationToUpdate,
  federationToUpdate,
  qualificationToUpdate,
  appreciationToUpdate,
}: UpdateCertificatesModalProps) => {
  const token = localStorage.getItem("token");
  const { userData } = useContext(ContextProvider);
  const [selectData, setSelectData] = useState<{
    education?: Education[];
    federation?: Federation[];
  }>({});

  const [actionLoaders, setActionLoaders] = useState({
    addedCertificate: false,
  });
  const [subSpecData, setSubSpecData] = useState<
    { value: string; lable: string }[]
  >([]);
  const getSubSpecializations = async (mainSpec: string) => {
    if (token && userData) {
      const subSpecResponse = await SpecialistApi.getSubSpecializations(token, [
        mainSpec,
      ]);

      if (subSpecResponse.status && subSpecResponse.subSpecializations) {
        const subSpecData = subSpecResponse.subSpecializations.map((item) => ({
          value: item._id,
          lable: item.labels.find((item) => item.language === "en")?.text!,
        }));

        setSubSpecData(subSpecData);
      }
    }
  };
  useEffect(() => {
    getSubSpecializations(mainSpec);
  }, [mainSpec]);

  const getEducations = async () => {
    const response = await SpecialistApi.getEducations(
      mainSpec,
      userData?.selectedLanguage
    );
    if (response.status && response.educations) {
      setSelectData((prev) => ({ ...prev, education: response.educations }));
    }
  };

  const getFederations = async () => {
    const response = await SpecialistApi.getFederations(
      mainSpec,
      userData?.selectedLanguage
    );

    if (response.status && response.federations) {
      setSelectData((prev) => ({ ...prev, federation: response.federations }));
    }
  };

  useEffect(() => {
    getEducations();
    getFederations();
  }, []);

  return (
    <ModalWindow
      isOpen={modalOpen}
      setIsOpen={setModalOpen}
      width="fit-content"
      bgColor="#1b1b1b"
    >
      {certificateType === "federation" ? (
        <FederationsCertificates
          selectData={selectData}
          setActionLoaders={setActionLoaders}
          setModalOpen={setModalOpen}
          specialistId={specialistId}
          specialization={mainSpec}
          setNewCertificate={setNewCertificate}
          setupUpdateCertificate={setupUpdateCertificate}
          actionLoaders={actionLoaders}
          setShowSendReviewRequestBtn={setShowSendReviewRequestBtn}
          federationToUpdate={federationToUpdate}
        />
      ) : certificateType === "qualification" ? (
        <QualificationsCertificates
          selectData={selectData}
          setActionLoaders={setActionLoaders}
          setModalOpen={setModalOpen}
          specialistId={specialistId}
          specialization={mainSpec}
          setNewCertificate={setNewCertificate}
          setupUpdateCertificate={setupUpdateCertificate}
          actionLoaders={actionLoaders}
          setShowSendReviewRequestBtn={setShowSendReviewRequestBtn}
          qualificationToUpdate={qualificationToUpdate}
        />
      ) : certificateType === "appreciation" ? (
        <Appreciation
          appreciationToUpdate={appreciationToUpdate}
          setNewCertificate={setNewCertificate}
          setupUpdateCertificate={setupUpdateCertificate}
          actionLoaders={actionLoaders}
          setShowSendReviewRequestBtn={setShowSendReviewRequestBtn}
          setActionLoaders={setActionLoaders}
          setModalOpen={setModalOpen}
          specialistId={specialistId}
        />
      ) : (
        <EducationsCertificates
          selectData={selectData}
          setActionLoaders={setActionLoaders}
          setModalOpen={setModalOpen}
          specialistId={specialistId}
          specialization={mainSpec}
          setNewCertificate={setNewCertificate}
          setupUpdateCertificate={setupUpdateCertificate}
          subSpecData={subSpecData}
          actionLoaders={actionLoaders}
          setShowSendReviewRequestBtn={setShowSendReviewRequestBtn}
          educationToUpdate={educationToUpdate}
        />
      )}
    </ModalWindow>
  );
};

export default UpdateCertificatesModal;
